/* eslint-disable import/prefer-default-export */

// Validation for delivery datetime to be after first pickup datetime in multi-stop request form
export function validateDeliveryDateTime({ stops, trigger, index }: { stops: any[]; trigger: any; index: number }) {
  const stop = stops?.[index];
  if (!stop) return;
  const fieldNames = [`schedule.stops.${index}.stop_after_date`, `schedule.stops.${index}.stop_before_date`];
  trigger(fieldNames);
}
